module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./packages/lui-layer-theme/theme/lui-brandmembranelayer-theme.global.scss
// module id = 162
// module chunks = 0 1 19